import { accounting } from '@/localize'
import { useCore } from '@/composables/core'

const countDecimals = (num: number): number => {
  const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)
  if (!match) { return 0 }
  return Math.max(
    0,
    (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0))
}

const DEFAULT_DECIMAL_DIGITS = 2

export type FormatCurrencyOptions = {
  decimalDigits?: number | 'auto'
  currency?: string
}

export function formatCurrency (value = 0.0, {
  decimalDigits = DEFAULT_DECIMAL_DIGITS,
  currency,
}: FormatCurrencyOptions = {}): string {
  const core = useCore()
  const defaultCurrency: string | undefined = (core.store.state as any).routingConfig?.config?.default_currency

  if (!defaultCurrency && !currency) {
    throw Error('No `default_currency` in the store or `currency` as param specified')
  }

  let resolvedDecimalDigits: number = typeof decimalDigits === 'number' ? decimalDigits : DEFAULT_DECIMAL_DIGITS

  if (decimalDigits === 'auto') {
    const decimalDigitsCount = countDecimals(value)

    resolvedDecimalDigits = decimalDigitsCount > 2
      ? decimalDigitsCount
      : DEFAULT_DECIMAL_DIGITS
  }

  const options: { precision: number; symbol?: string } = { precision: resolvedDecimalDigits }

  if (currency && currency !== defaultCurrency) {
    options.symbol = currency
  }

  return accounting.formatMoney(value * 1.0, options)
}
